import {
    FETCH_BANK_FIELD_REQUIREMENTS,
    FETCH_BANK_FIELD_REQUIREMENTS_SUCCESS,
    FETCH_BANK_FIELD_REQUIREMENTS_FAILED,
    EDIT_BANK_FIELD_REQUIREMENTS,
    EDIT_BANK_FIELD_REQUIREMENTS_SUCCESS,
    EDIT_BANK_FIELD_REQUIREMENTS_FAILED,
    CLEAR_BANK_FIELD_ERROR
} from '../store/types';

const initialState = {
    data: {
        accountHolderName: { show: true, required: true, driver: true, user: true },
        accountNumber: { show: true, required: true, driver: true, user: true },
        iban: { show: false, required: false, driver: false, user: false },
        bankName: { show: true, required: true, driver: true, user: true },
        bankCode: { show: false, required: false, driver: false, user: false },
        branchCode: { show: false, required: false, driver: false, user: false },
        routingNumber: { show: false, required: false, driver: false, user: false },
        swiftCode: { show: false, required: false, driver: false, user: false },
        bankAddress: { show: false, required: false, driver: false, user: false },
        accountType: { show: false, required: false, driver: false, user: false },
        currency: { show: false, required: false, driver: false, user: false },
        country: { show: true, required: true, driver: true, user: true },
        recipientAddress: { show: false, required: false, driver: false, user: false },
        emailOrPhone: { show: false, required: false, driver: false, user: false },
        enableForUsers: true,
        enableForDrivers: true
    },
    loading: false,
    error: null,
    saving: false,
    saveSuccess: false
};

export const bankFieldReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_BANK_FIELD_REQUIREMENTS:
            return {
                ...state,
                loading: true,
                error: null
            };
        case FETCH_BANK_FIELD_REQUIREMENTS_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload,
                error: null
            };
        case FETCH_BANK_FIELD_REQUIREMENTS_FAILED:
            return {
                ...state,
                loading: false,
                error: action.payload
            };
        case EDIT_BANK_FIELD_REQUIREMENTS:
            return {
                ...state,
                saving: true,
                saveSuccess: false,
                error: null
            };
        case EDIT_BANK_FIELD_REQUIREMENTS_SUCCESS:
            return {
                ...state,
                saving: false,
                saveSuccess: true,
                data: action.payload,
                error: null
            };
        case EDIT_BANK_FIELD_REQUIREMENTS_FAILED:
            return {
                ...state,
                saving: false,
                saveSuccess: false,
                error: action.payload
            };
        case CLEAR_BANK_FIELD_ERROR:
            return {
                ...state,
                error: null,
                saveSuccess: false
            };
        default:
            return state;
    }
};

export default bankFieldReducer;